import { Global } from "../Shared/Global"

class MsgCenterData {
    private _msgList = []

    set msgList (value: Array<any>) {
        this._msgList = value
        cc.director.emit(Global.UserEvent.MsgListChanged)
    }
    
    get msgList () {
        return this._msgList
    }

    getMsgs (msgType) {
        let msgs = []

        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i];
            if (msg.messageType === msgType) {
                msgs.push(msg)
            }
        }

        return msgs
    }

    getMsgData (id) {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i];

            if (msg.id === id) {
                return msg
            }
        }
    }

    readMsg (id) {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i];

            if (msg.id === id) {
                msg.readed = true
                cc.director.emit(Global.UserEvent.MsgListChanged)
                break
            }
        }
    }

    readAllMsg () {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i]
            msg.readed = true
        }

        cc.director.emit(Global.UserEvent.MsgListChanged)
    }

    delMsg (id) {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i];
            
            if (msg.id === id) {
                this._msgList.splice(i, 1)
                cc.director.emit(Global.UserEvent.MsgListChanged)
                break
            }
        }
    }

    delAllMsg () {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i]

            // 未领取不能删除
            if (msg.validType !== 0) {
                this._msgList.splice(i, 1)
                i--
            }
        }
        cc.director.emit(Global.UserEvent.MsgListChanged)
    }

    receiveAward (id) {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i];

            if (msg.id === id) {
                if (msg.validType === 0) {
                    msg.validType = 1
                    cc.director.emit(Global.UserEvent.MsgListChanged)
                }
                break
            }
        }
    }

    receiveAllAward () {
        for (let i = 0; i < this._msgList.length; i++) {
            const msg = this._msgList[i]

            if (msg.validType === 0) {
                msg.validType = 1
                msg.readed = true
            }
        }

        cc.director.emit(Global.UserEvent.MsgListChanged)
    }
}

export default new MsgCenterData()